<template>
  <ConnectInstancesDialog
    :show="true"
    :btnLoadding="confirmButtonLoadingStatus"
    :showEmailNotify="false"
    :showIntervalSecOptions="false"
    @clickClose="clickClose"
    @clickConfirm="clickConfirm"
  >
    <template v-slot:content>
      <el-transfer
        v-model="selectedKeys"
        :data="transferData"
        :props="{ key: 'deviceKey', label: 'name' }"
        :titles="['Available', 'Selected']"
        :filterable="true"
        filter-placeholder="filter by name"
        class="devices-transfer"
      />
    </template>
  </ConnectInstancesDialog>
</template>

<script>
import { confirmConnectInstance } from '../api'
import ConnectInstancesDialog from './template/ConnectInstancesDialog.vue'

export default {
  name: 'SelectDevicesTransfer',
  components: { ConnectInstancesDialog },
  props: {
    integrationDeviceList: { type: Array, default: () => [] },
    selectedDeviceKeys:    { type: Array, default: () => [] },
    connectInstanceVo:     { type: Object, default: () => ({}) },
  },
  data() {
    return {
      confirmButtonLoadingStatus: false,
      selectedKeys: (this.selectedDeviceKeys || []).slice(),
    }
  },
  computed: {
    transferData() {
      return this.integrationDeviceList.map(d => ({ deviceKey: d.deviceKey, name: d.name }))
    },
  },
  methods: {
    clickClose() {
      this.$emit('clickClose')
    },
    clickConfirm() {
      if (!this.integrationDeviceList.length) {
        this.$message.info({ center: true, message: 'Now instance has no device!' })
        return
      }
      if (!this.selectedKeys.length) {
        this.$message.error({ center: true, message: 'Please select at least one device!' })
        return
      }
      const selectedSet = new Set(this.selectedKeys)
      const selectedDevices = this.integrationDeviceList.filter(d => selectedSet.has(d.deviceKey))
      this.confirmButtonLoadingStatus = true
      confirmConnectInstance(this.connectInstanceVo, selectedDevices)
        .then(() => { this.$emit('selectDevicesComfirm') })
        .catch(() => { this.$message.error({ center: true, message: 'Network Error!' }) })
        .finally(() => { this.confirmButtonLoadingStatus = false })
    },
  },
}
</script>

<style scoped>
/* Widen the dialog to fit both panels */
::v-deep .el-transfer {
  display: flex;
  align-items: center;
}

/* Panels */
::v-deep .el-transfer-panel {
  width: 240px;
  background: #1a2535;
  border: 1px solid #333B47;
  border-radius: 4px;
}

::v-deep .el-transfer-panel__header {
  background: #1a2535;
  border-bottom: 1px solid #333B47;
  color: #cfd1d4;
}

::v-deep .el-transfer-panel__header .el-checkbox__label {
  color: #cfd1d4;
  font-size: 14px;
}

::v-deep .el-transfer-panel__body {
  background: #1a2535;
}

/* Search input */
::v-deep .el-transfer-panel__filter .el-input__inner {
  background: #182130;
  border-color: #333B47;
  color: #fff;
}
::v-deep .el-transfer-panel__filter .el-input__inner::placeholder {
  color: #8a9ab0;
}
::v-deep .el-transfer-panel__filter .el-input__icon {
  color: #8a9ab0;
}

/* List items */
::v-deep .el-transfer-panel__list {
  background: #1a2535;
}
::v-deep .el-transfer-panel__item.el-checkbox {
  color: #fff;
}
::v-deep .el-transfer-panel__item .el-checkbox__label {
  color: #fff;
  font-size: 14px;
}
::v-deep .el-transfer-panel__item.el-checkbox.is-checked .el-checkbox__label {
  color: #FCB900;
}

/* Checkboxes */
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FCB900;
  border-color: #FCB900;
}
::v-deep .el-checkbox__inner {
  background: #182130;
  border-color: #555;
}

/* Empty text */
::v-deep .el-transfer-panel__empty {
  color: #8a9ab0;
}

/* Arrow buttons */
::v-deep .el-transfer__buttons .el-button {
  background: #2c3850;
  border: 1px solid #3d4f68;
  color: #fff;
  display: block;
  margin: 0 0 8px 0 !important;
  padding: 8px 12px;
}
::v-deep .el-transfer__buttons .el-button:last-child {
  margin-bottom: 0 !important;
}
::v-deep .el-transfer__buttons .el-button:hover:not(.is-disabled) {
  background: #FCB900;
  border-color: #FCB900;
}
::v-deep .el-transfer__buttons .el-button.is-disabled {
  opacity: 0.4;
}
::v-deep .el-transfer__buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
}

/* Scrollbar */
::v-deep .el-transfer-panel__list::-webkit-scrollbar {
  width: 5px;
}
::v-deep .el-transfer-panel__list::-webkit-scrollbar-thumb {
  background-color: #555;
}
</style>
